<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
		<path
			fill="#FE196D"
			stroke="#FE196D"
			d="M8.693 3.344a1.5 1.5 0 0 1 2.615 0l5.58 9.92A1.5 1.5 0 0 1 15.58 15.5H4.42a1.5 1.5 0 0 1-1.307-2.236l5.58-9.92ZM10 14.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0-10A1.5 1.5 0 0 0 8.5 6v3a1.5 1.5 0 1 0 3 0V6A1.5 1.5 0 0 0 10 4.5Z"
		/>
	</svg>
</template>
